import React from 'react';

function Outscale() {
    return <><h1>Outscale</h1> déso c'était lié au défi de SFEIR mais vu qu'on a pas réussi on a pas fait le votre. l’easter egg avait pour but de déclencher le snap de thanos et de faire disparaitre la moitié des éléments de la page SFEIR aléatoirement</>;
}

export default Outscale;